/**------------------------------------------------------
 * List of Events
 */
export enum EnumNgEventName {
	MouseHover		= 'mouse_hover',
	Click 			= 'click',
	MouseKey 		= 'mouse_key'
	// DoubleClick 	= 'double_click',
	// Blur 		= 'blur',
	// Focus 		= 'focus',
	// Submit 		= 'submit',
	// Scroll	 	= 'scroll',
	// Keyup 		= 'keyup',
	// Keypress 	= 'keypress',
	// Keydown 		= 'keydown',
	// MouseUp 		= 'mouseup',
	// MouseDown 	= 'mousedown',
	// MouseEnter 	= 'mouse_enter',
	// MouseLeave 	= 'mouse_leave',
	// Cut 			= 'cut',
	// copy 		= 'copy',
	// Paste 		= 'paste',
	// Drag 		= 'drag',
	// Drop 		= 'drop',
	// Dragover 	= 'dragover'
}


/**------------------------------------------------------
 * Event Trigger Configurations
 */
export const NG_EVENT_TRIGGERS: Record<EnumNgEventName, INgEventTriggers> = {
	[EnumNgEventName.MouseHover]: {
		start	: 'mouseenter',
		end		: 'mouseleave'
	},
	[EnumNgEventName.Click]: {
		start	: 'click',
		end		: 'click'
	},
	[EnumNgEventName.MouseKey]: {
		start	: 'mousedown',
		end		: 'mouseup'
	}
};


//** Interfaces --------------------------------- */
export interface INgEventTriggers {
	start		: string;
	end			: string;
}
